/**
 * studio-shop D1 — every plug-in Telify has, one declaration each
 * (`<id>.plugin.ts`). Read by the API (route gates, the studio read's
 * `plugins`), the kit (which pieces a studio may place) and the checks.
 * Pure and browser-safe.
 */
import type { TenantFeature } from '../tenant-context/tenant-features.js';
import { bookingPlugin } from './booking.plugin.js';
import type { PluginDeclaration } from './define.js';
import { emailListPlugin } from './email-list.plugin.js';
import { formsPlugin } from './forms.plugin.js';
import { shopPlugin } from './shop.plugin.js';

export const PLUGINS: readonly PluginDeclaration[] = [bookingPlugin, shopPlugin, formsPlugin, emailListPlugin];

export function findPlugin(id: string): PluginDeclaration | undefined {
  return PLUGINS.find((p) => p.id === id);
}

/** The plug-in a website piece belongs to. */
export function pluginOfPiece(piece: string): PluginDeclaration | undefined {
  return PLUGINS.find((p) => p.pieces.includes(piece));
}

/** The plug-ins a studio's switches turn on, by id: the studio read's `plugins`. */
export function enabledPlugins(features: readonly TenantFeature[]): string[] {
  return PLUGINS.filter((p) => features.includes(p.feature)).map((p) => p.id);
}

export interface PluginRoutePolicyEntry {
  readonly prefix: string;
  readonly feature: TenantFeature;
  readonly plugin: string;
}

/** The route gate's plug-in entries: each declared route prefix, refused while its plug-in's switch is off. */
export function pluginRoutePolicy(plugins: readonly PluginDeclaration[] = PLUGINS): PluginRoutePolicyEntry[] {
  return plugins.flatMap((p) =>
    [p.siteRoutes, p.adminRoutes].flatMap((r) => (r ? [{ prefix: r.prefix, feature: p.feature, plugin: p.id }] : [])),
  );
}
